
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ShowScimToken',
  props: {
    token: {
      type: String,
      required: true
    },
    teamName: {
      type: String,
      required: true
    }
  }
})
